module.exports = __webpack_public_path__ + "img/ml3098.fa38b5db.png";